import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  max-width: ${pxToRem(300)};
  margin: 0 auto;
`;
export const OverlayButton = styled.button `
  background-color: transparent;
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  border-radius: ${theme.borderRadius.lg};
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 0.2s ease-in-out;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 ${pxToRem(4)} ${theme.semantic.focus.ring};
  }
`;
export const HoverContent = styled.div `
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.xl};
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
`;
export const ImageContainer = styled.div `
  position: relative;
  background-image: url(${(props) => props.$src});
  background-size: cover;
  background-position: center center;
  height: ${pxToRem(150)};
  border-radius: ${theme.borderRadius.lg};
  margin-bottom: ${theme.spacing.lg};
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);

    ${OverlayButton} {
      background-color: color-mix(in srgb, ${theme.semantic.surface.inverse}, transparent 95%);
    }

    ${HoverContent} {
      opacity: 1;
    }
  }
`;
export const TitleContainer = styled.div `
  padding-inline: ${theme.spacing.md};
`;
export const AlignRight = styled.div `
  display: flex;
  margin-left: auto;
`;
